import { render } from "./BaseInput.vue?vue&type=template&id=ff4b2056&scoped=true"
import script from "./BaseInput.vue?vue&type=script&lang=ts"
export * from "./BaseInput.vue?vue&type=script&lang=ts"

import "./BaseInput.vue?vue&type=style&index=0&id=ff4b2056&lang=css"
import "./BaseInput.vue?vue&type=style&index=1&id=ff4b2056&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-ff4b2056"

export default script